var activeAjaxRequests = 0; 

  function generarStringAleatorio(longitud) {
    var caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var resultado = '';
    var caracteresLongitud = caracteres.length;
    for (var i = 0; i < longitud; i++) {
      resultado += caracteres.charAt(Math.floor(Math.random() * caracteresLongitud));
    }
    return resultado;
  }

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((detailsElement) => {
  detailsElement.addEventListener('click', (event) => {
    if (event.currentTarget.classList.contains('isMenuMain')) 
    {
      event.preventDefault();
      return; 
    }
    
  });
});

/*
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => 
{ 
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => 
  {
    console.log("nothing");
    console.log(event.currentTarget.classList);
    if (event.currentTarget.classList.contains('isMenuMain')) 
    {
      console.log("** ",event.currentTarget);
      return; 
    }
    
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
*/



const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) 
  {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) 
  {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) 
  {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    window.selected_variant_data = this.currentVariant;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function scrollToAnimate(to, duration) {
    var start = window.pageYOffset;
    var startTime = performance.now();

    function animate(currentTime) {
      var currentTimeElapsed = currentTime - startTime;
      var progress = Math.min(currentTimeElapsed / duration, 1);
      var easeFunction = easeOutQuad(progress);

      window.scrollTo(0, start + (to - start) * easeFunction);

      if (currentTimeElapsed < duration) {
        requestAnimationFrame(animate);
      }
    }

    function easeOutQuad(t) {
      return t * (2 - t);
    }

    requestAnimationFrame(animate);
}


        
function slideDown(element) {
    var height = element.offsetHeight;
    element.style.maxHeight = '0';
    element.style.transition = 'max-height 0.3s ease-in-out';
    setTimeout(function() {
      element.style.maxHeight = height + 'px';
    }, 10);
}

function copyMenuContent(source, destination) 
{
  var newHtmlContent = source.innerHTML;
  destination.innerHTML = '<ul id="HeaderMenu-MenuList-1" class="sera1 header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1">'+newHtmlContent+'</ul>';   
}



function copyMenuContent2(source, destination)
{
  var newHtmlContent = source.innerHTML;

  if (window.innerWidth > 768) 
  {
      var newHtmlContent = source.innerHTML;
      destination.innerHTML = '<ul id="HeaderMenu-MenuList-1" class="sera1 header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1">'+newHtmlContent+'</ul>';   
  } else {
        // Convertir el string HTML en elementos DOM
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHtmlContent;
        
        // Encontrar el elemento con ID 'HeaderMenu-SubMenuList-1'
        var menuList = tempDiv.querySelector('#HeaderMenu-SubMenuList-1');
        if (menuList && menuList.children.length >= 4) {
            // Identificar el segundo y cuarto elementos
            var secondItem = menuList.children[1]; // Elemento actual en la segunda posición
            var fourthItem = menuList.children[3]; // Elemento actual en la cuarta posición
        
            // Clonar estos elementos
            var secondItemClone = secondItem.cloneNode(true);
            var fourthItemClone = fourthItem.cloneNode(true);
        
            // Remover los elementos originales de sus posiciones
            menuList.removeChild(secondItem);
            menuList.removeChild(fourthItem);
        
            // Añadir los clones al final de la lista
            menuList.appendChild(secondItemClone);
            menuList.appendChild(fourthItemClone);
        }
        
        // Obtener el HTML actualizado
        var newHtmlContent = tempDiv.innerHTML;
        destination.innerHTML = '<ul id="HeaderMenu-MenuList-1" class="sera10 header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1">'+newHtmlContent+'</ul>';       
  }
}

function copyMenuContent3(source, destination)
{
  var newHtmlContent = source.innerHTML;

  if (window.innerWidth > 768) 
  {
      // Convertir el string HTML en elementos DOM
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtmlContent;
      
      // Encontrar el elemento con ID 'HeaderMenu-SubMenuList-1'
      var menuList = tempDiv.querySelector('#HeaderMenu-SubMenuList-1');
      if (menuList && menuList.children.length >= 5) {
          var listItems = Array.from(menuList.children);
      
          // Mover el último elemento a la cuarta posición
          var lastItem = listItems.pop(); // Remueve el último elemento
          menuList.insertBefore(lastItem, listItems[3]); // Inserta el último elemento en la cuarta posición
      
          // Ahora intercambiar el tercer y cuarto elementos
          var thirdItem = menuList.children[2]; // Elemento actual en la tercera posición
          var fourthItem = menuList.children[3]; // Elemento actual en la cuarta posición (que era el último)
      
          menuList.insertBefore(fourthItem, thirdItem); // Mueve el cuarto antes del tercero
          menuList.insertBefore(thirdItem, fourthItem.nextSibling); // Mueve el tercero a la posición del cuarto
      }
      
      // Obtener el HTML actualizado
      var newHtmlContent = tempDiv.innerHTML;
  } else {
        // Convertir el string HTML en elementos DOM
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHtmlContent;
        
        // Encontrar el elemento con ID 'HeaderMenu-SubMenuList-1'
        var menuList = tempDiv.querySelector('#HeaderMenu-SubMenuList-1');
        if (menuList && menuList.children.length >= 4) {
            // Identificar el segundo y cuarto elementos
            var secondItem = menuList.children[1]; // Elemento actual en la segunda posición
            var fourthItem = menuList.children[3]; // Elemento actual en la cuarta posición
        
            // Clonar estos elementos
            var secondItemClone = secondItem.cloneNode(true);
            var fourthItemClone = fourthItem.cloneNode(true);
        
            // Remover los elementos originales de sus posiciones
            menuList.removeChild(secondItem);
            menuList.removeChild(fourthItem);
        
            // Añadir los clones al final de la lista
            menuList.appendChild(secondItemClone);
            menuList.appendChild(fourthItemClone);
        }
        
        // Obtener el HTML actualizado
        var newHtmlContent = tempDiv.innerHTML;

  }
    
  destination.innerHTML = '<ul id="HeaderMenu-MenuList-1" class="sera1 header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1">'+newHtmlContent+'</ul>';       
}

function copyMenuContentWithoutSecondLi(source, destination) 
{
    var clonedContent = source.cloneNode(true);
    var secondLi = clonedContent.querySelector('li:nth-child(2)');
    if (secondLi) {
      clonedContent.removeChild(secondLi);
    }

    destination.innerHTML = '<ul id="HeaderMenu-MenuList-1" class="sera header__submenu list-menu list-menu--disclosure gradient caption-large motion-reduce global-settings-popup" role="list" tabindex="-1">'+clonedContent.innerHTML+'</ul>';

}

document.addEventListener("DOMContentLoaded", function() {

  window.onload = function()
  {
    const headertopCustom = document.querySelector('.headertopCustom');
    headertopCustom.style.top = '0';

    setTimeout(function() 
    {
      const h2Element = document.querySelector('#shopify-section-template--19872002703654__f80aa510-b2a0-4f58-9a6e-67620c972d3f h1');

      if(h2Element != null)
      {
        
        h2Element.style.opacity = '1';  
  
        setTimeout(function() 
        {
          const Rosado = document.querySelector('.card_rosado img');
          Rosado.style.opacity = '1'; 
          Rosado.style.top = '15em';
  
          setTimeout(function() 
          {
            const Celeste = document.querySelector('.card_celeste img');
            Celeste.style.opacity = '1'; 
  
            if (window.innerWidth < 760) {
                Celeste.style.top = '20.3em';
            } else {
                Celeste.style.top = '24em';
            }
            
            Celeste.style.transform = 'rotate(0deg)';
  
            setTimeout(function() 
            {    
              const Yellow = document.querySelector('.card_yellow img');
              Yellow.style.opacity = '1'; 
              
              if (window.innerWidth < 760) {
                  Yellow.style.top = '18.3em';
              } else {
                  Yellow.style.top = '20.3em';
              }
              Yellow.style.transform = 'rotate(0deg)';
    
               setTimeout(function() 
              {    
                  const btnBottom = document.querySelector('#shopify-section-template--19872002703654__f80aa510-b2a0-4f58-9a6e-67620c972d3f a');
                  btnBottom.style.opacity = '1';  
              }, 200);
                
            }, 200);
          
          }, 200);
          
        }, 600);
      }


      var buttonBody = document.querySelector('body.about');
      if(buttonBody) 
      {
         var buttons = document.querySelectorAll('a.button');
         var menuContent = document.getElementById('HeaderMenu-MenuList-1');
         
          for (var i = 0; i < buttons.length; i++) 
          {
            if (buttons[i].textContent === 'Shop all') 
            {
                var newDiv = document.createElement('div');
                newDiv.id = 'openCollectionHome';
                newDiv.style.display = 'none';
             
                buttons[i].parentNode.insertBefore(newDiv, buttons[i]);
                buttons[i].href = "#";
                newDiv.parentNode.classList.add('viewallrelative3');
                var collectionDiv = document.getElementById('openCollectionHome');
                copyMenuContent2(menuContent, collectionDiv);  
                
                buttons[i].addEventListener('click', function(event) 
                {
                  event.preventDefault();
                  if (collectionDiv.style.display == 'none') {
                    collectionDiv.style.display = 'block';
                    slideDown(collectionDiv);
                  } else {
                    collectionDiv.style.display = 'none';
                  }
                });
                
                
              
                break;
            }
          }
      }

      var buttonBody2 = document.querySelector('.showPopupCollectionHome');
      if(buttonBody2) 
      {
         
         var buttons2 = document.querySelectorAll('a.button');
         var menuContent2 = document.getElementById('HeaderMenu-MenuList-1');
         
          for (var i = 0; i < buttons2.length; i++) 
          {
            if (buttons2[i].textContent.trim() === 'Shop all' && i > 4) 
            {
                var newDiv = document.createElement('div');
                newDiv.id = 'openCollectionHome2';
                newDiv.style.display = 'none';
              
                buttons2[i].parentNode.insertBefore(newDiv, buttons2[i]);
                buttons2[i].href = "#";
                newDiv.parentNode.classList.add('viewallrelative3');
                var collectionDiv2 = document.getElementById('openCollectionHome2');
                copyMenuContent2(menuContent2, collectionDiv2);  
              
                buttons2[i].addEventListener('click', function(event) 
                {
                  event.preventDefault();
                  if (collectionDiv2.style.display == 'none') {
                    collectionDiv2.style.display = 'block';
                    slideDown(collectionDiv2);
                  } else {
                    collectionDiv2.style.display = 'none';
                  }
                });

                const summaryElements = document.querySelectorAll("summary.isMenuMain");
                if (summaryElements) {
                  summaryElements.forEach(function (summaryElement) {
                    summaryElement.addEventListener("click", function (event) {
                      event.preventDefault(); 
                    });
                  });
                }
                
                
              
                break;
            }
          }
      }
    }, 600);

    setTimeout(function(){
      const IssetAddOn = document.getElementById("avpoptions-container__v2");
      if(!IssetAddOn)
      {
        const Isseth4AddOn = document.querySelector(".h4addon");
        if(Isseth4AddOn){
          document.querySelector(".h4addon").style.display = 'none';  
        }
      }
    }, 1200);
    
    const jQueryDom = document.querySelector('#shopify-section-template--19872002703654__f80aa510-b2a0-4f58-9a6e-67620c972d3f .rich-text__text');
    if (jQueryDom !== null) 
    {
      const nuevoDiv = document.createElement('div');
      nuevoDiv.textContent = '';
      nuevoDiv.setAttribute('class', 'card_celeste');
      const imagen4 = document.createElement('img');
      imagen4.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0747/8440/7846/files/cyan-badge.svg?v=1690243843');
      imagen4.setAttribute('alt', 'Event badges for everyone.');
      nuevoDiv.appendChild(imagen4);
  
      const nuevoDiv2 = document.createElement('div');
      nuevoDiv2.textContent = '';
      nuevoDiv2.setAttribute('class', 'card_yellow');
      const imagen5 = document.createElement('img');
      imagen5.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0747/8440/7846/files/yellow-badge.svg?v=1690243843');
      imagen5.setAttribute('alt', 'Event badges for everyone.');
      nuevoDiv2.appendChild(imagen5);
  
      const nuevoDiv3 = document.createElement('div');
      nuevoDiv3.textContent = '';
      nuevoDiv3.setAttribute('class', 'card_rosado');
      const imagen6 = document.createElement('img');
      imagen6.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0747/8440/7846/files/magenta-badge.svg?v=1690243843');
      imagen6.setAttribute('alt', 'Event badges for everyone.');
      nuevoDiv3.appendChild(imagen6);
  
      const nuevoDiv4 = document.createElement('div');
      nuevoDiv4.textContent = '';
      nuevoDiv4.setAttribute('class', 'card_escarcha');
  
      jQueryDom.appendChild(nuevoDiv);
      jQueryDom.appendChild(nuevoDiv2);
      jQueryDom.appendChild(nuevoDiv3);
      jQueryDom.appendChild(nuevoDiv4);
    }
     var linkButton = document.querySelector("#shopify-section-template--18793719431331__image_banner_Pq44fR a");
     var destinationSection = document.querySelector("#shopify-section-template--18793719431331__multicolumn_zVbtNE");

    if(linkButton != null){
        linkButton.addEventListener("click", function(event) {
          event.preventDefault();
      
          var offset = destinationSection.getBoundingClientRect().top + window.pageYOffset;
          scrollToAnimate(offset, 1000);
        });
    }

    var elements = document.querySelectorAll(".detail_product_main section:nth-child(3) ul li:nth-child(3) .multicolumn-card__info a");
    if(elements !=null){
      elements.forEach(function(element) {
        element.setAttribute("target", "_blank");
        element.setAttribute("data-icon", element.textContent.toLowerCase());
      });  
    }

    function GenerateComas()
    {
          var table = document.querySelector('.tbl-qb-grid');
          if(table) 
          {
              var quantityCells = table.querySelectorAll('tbody tr td:first-child');
      
              function numberWithCommas(x) {
                  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
      
              function parseNumber(text) {
                  var num = parseInt(text.replace(/[^\d]/g, ''));
                  return isNaN(num) ? 0 : num;
              }
      
              for (var i = 0; i < quantityCells.length; i++) {
                  var quantityText = quantityCells[i].innerText.trim();
                  var quantityRange = quantityText.split('-').map(parseNumber);
      
                  var formattedRange = quantityRange.map(function(num, index) {
                      if (index === quantityRange.length - 1 && quantityText.includes('+')) 
                      {
                          return numberWithCommas(num) + " +";
                      }
                      else{
                        return numberWithCommas(num);
                      }
                      
                  }).join(' - ');

                  quantityCells[i].innerText = formattedRange.replace("- 0 +","+");
              }
          }    
    }

    GenerateComas()
    setTimeout(function()
    {
        GenerateComas();
    }, 250);

    var showPopupLink = document.querySelector('.showPopupCollectionHome');
    var collectionDiv = document.getElementById('openCollectionHome');
    var menuContent = document.getElementById('HeaderMenu-MenuList-1');

    if(showPopupLink != null){
          showPopupLink.addEventListener('click', function(event) {
            event.preventDefault();
            if (collectionDiv.style.display == 'none') {
              collectionDiv.style.display = 'block';
              slideDown(collectionDiv);
            } else {
              collectionDiv.style.display = 'none';
            }
          });
            
          copyMenuContent3(menuContent, collectionDiv);
    }


setTimeout(function() {
    var upsellHeader = document.querySelector('.h4addon');
    var upsellAddonContainer = document.getElementById('avpoptions-container__v2');
    var isContainerVisible = true; // Estado inicial

    if (upsellHeader != null) {
        upsellHeader.addEventListener('click', function() {
            if (isContainerVisible) {
                upsellAddonContainer.style.maxHeight = '0';
                upsellAddonContainer.addEventListener('transitionend', function() {
                    upsellAddonContainer.style.display = 'none';
                }, { once: true });
            } else {
                upsellAddonContainer.style.display = 'block';
                upsellAddonContainer.style.maxHeight = '500px'; // Altura máxima
            }

            // Cambiar el estado
            isContainerVisible = !isContainerVisible;

            // Toggle la clase "active" en h4addon
            upsellHeader.classList.toggle('active');
        });
    }
}, 3000);

    if(typeof CustomerAddresses !== 'undefined')
    {
        new CustomerAddresses();
    }




    BtnClickSimulator();    
    
  }
});

    
async function ExecOtherCode()
{
        // ========== SEPARATE KIT PRODUCT HANDLING ==========
        // Kit products have their own flow with upload check but dynamic button finding
        const isKitProduct = document.querySelector('.kit-product') !== null;
        console.log('[Kit Product] isKitProduct:', isKitProduct);
        if (isKitProduct) {
            console.log('[Kit Product] Entering Kit product handling');
            const submitButton = document.getElementById('ProductSubmitButton-template--cs');
            const spinnerDivs = document.querySelectorAll('.loading-overlay__spinner');
            const existsPlugin = document.querySelector('.uploadkit-button');
            const existsFile = document.querySelector('.uploadkit-button-uploaded');
            console.log('[Kit Product] existsPlugin:', existsPlugin);
            console.log('[Kit Product] existsFile:', existsFile);

            // Upload check for Kit products
            if (existsPlugin && existsFile == null) {
                var msg_minimum_order = document.querySelectorAll('.msg_minimum_order');

                if (msg_minimum_order.length > 0) { return; }

                var msgMinimumOrder = document.createElement('div');
                msgMinimumOrder.className = 'msg_minimum_order';
                msgMinimumOrder.textContent = window.UploadKit.config.uploaders[0].requiredMessage;

                var deleteMsgMinLink = document.createElement('a');
                deleteMsgMinLink.href = '#';
                deleteMsgMinLink.id = 'deleteMsgMin';

                msgMinimumOrder.appendChild(deleteMsgMinLink);

                // For Kit products, insert before .product-form__buttons
                var formButtons = document.querySelector('.product-form__buttons');
                if (formButtons) {
                    formButtons.parentNode.insertBefore(msgMinimumOrder.cloneNode(true), formButtons);
                }

                var deleteMsgMinLink = document.getElementById('deleteMsgMin');
                if (deleteMsgMinLink) {
                    deleteMsgMinLink.addEventListener('click', function (event) {
                        event.preventDefault();
                        var msgMinOrderDiv = document.querySelector('.msg_minimum_order');
                        if (msgMinOrderDiv) {
                            msgMinOrderDiv.parentNode.removeChild(msgMinOrderDiv);
                        }
                    });
                }

                return; // Exit - file not uploaded
            }

            // Find and click the hidden form submit button dynamically
            const hiddenSubmitBtn = document.querySelector('product-form button[type="submit"][name="add"]');
            if (hiddenSubmitBtn) {
                hiddenSubmitBtn.click();
            }

            // Show loading state
            if (submitButton) submitButton.classList.add('loading');
            spinnerDivs.forEach(function (spinnerDiv) {
                spinnerDiv.classList.remove('hidden');
            });

            // Remove loading state after delay
            setTimeout(function () {
                if (submitButton) submitButton.classList.remove('loading');
                spinnerDivs.forEach(function (spinnerDiv) {
                    spinnerDiv.classList.add('hidden');
                });
            }, 500);

            return; // Exit early - don't run regular product code
        }
        // ========== END KIT PRODUCT HANDLING ==========

        quantityInput = localStorage.getItem('quantityValue');
        // Check if quantity input exists before setting value (Kit products don't have this)
        const quantityInputEl = document.querySelector('#PDPQuantity .input_container input');
        if (quantityInputEl) {
            quantityInputEl.value = quantityInput;
        }

        const submitButton = document.getElementById('ProductSubmitButton-template--cs');
        const spinnerDivs = document.querySelectorAll('.loading-overlay__spinner');
        const existsPlugin = document.querySelector('.uploadkit-button');
        const existsFile = document.querySelector('.uploadkit-button-uploaded');

        if(existsPlugin && existsFile == null)
        {
            const qtyvalueEl = document.getElementById("qtyvalue");
            const qtylabelEl = document.getElementById("qtylabel");
            const pdpQuantityInputEl = document.querySelector("#PDPQuantity .input_container input");
            if (qtyvalueEl) qtyvalueEl.innerHTML = "";
            if (qtylabelEl) qtylabelEl.style.display = "none";
            if (pdpQuantityInputEl) pdpQuantityInputEl.classList.remove("changeVariantText");
          
            var inputElements = document.querySelectorAll('.product-form__input');
            var msg_minimum_order = document.querySelectorAll('.msg_minimum_order');

            if(msg_minimum_order.length > 0){return;}

            var msgMinimumOrder = document.createElement('div');
            msgMinimumOrder.className = 'msg_minimum_order';
            msgMinimumOrder.textContent = window.UploadKit.config.uploaders[0].requiredMessage;

            var deleteMsgMinLink = document.createElement('a');
            deleteMsgMinLink.href = '#';
            deleteMsgMinLink.id = 'deleteMsgMin';

            msgMinimumOrder.appendChild(deleteMsgMinLink);
            if (inputElements.length > 0) {
              inputElements[inputElements.length-1].parentNode.insertBefore(msgMinimumOrder.cloneNode(true), inputElements[inputElements.length-1]);
            }

            var deleteMsgMinLink = document.getElementById('deleteMsgMin');
            if (deleteMsgMinLink)
            {
                deleteMsgMinLink.addEventListener('click', function (event) {
                  event.preventDefault();
                  var msgMinOrderDiv = document.querySelector('.msg_minimum_order');
                  if (msgMinOrderDiv) {
                    msgMinOrderDiv.parentNode.removeChild(msgMinOrderDiv);
                  }
                });
            }
    
            return;
        }

        var checkbox = document.querySelector('input[type="checkbox"][value="Pre-Printed Names"]');
        if (checkbox && checkbox.checked) 
        {
            const existsFile2 = document.querySelector('div[data-uploader-id="7d3d35eb-2621-4989-961b-78d07b3e5ef4"] .uploadkit-button-uploaded');
            if(existsFile2 == null)
            {
              const qtyvalueEl2 = document.getElementById("qtyvalue");
              const qtylabelEl2 = document.getElementById("qtylabel");
              const pdpQuantityInputEl2 = document.querySelector("#PDPQuantity .input_container input");
              if (qtyvalueEl2) qtyvalueEl2.innerHTML = "";
              if (qtylabelEl2) qtylabelEl2.style.display = "none";
              if (pdpQuantityInputEl2) pdpQuantityInputEl2.classList.remove("changeVariantText");
              
              var inputElements = document.querySelectorAll('.product-form__input');
              var msg_minimum_order = document.querySelectorAll('.msg_minimum_order');

              if(msg_minimum_order.length > 0){return;}

              var msgMinimumOrder = document.createElement('div');
              msgMinimumOrder.className = 'msg_minimum_order';
              msgMinimumOrder.textContent = window.UploadKit.config.uploaders[1].requiredMessage;

              var deleteMsgMinLink = document.createElement('a');
              deleteMsgMinLink.href = '#';
              deleteMsgMinLink.id = 'deleteMsgMin';

              msgMinimumOrder.appendChild(deleteMsgMinLink);
              if (inputElements.length > 0) {
                inputElements[inputElements.length-1].parentNode.insertBefore(msgMinimumOrder.cloneNode(true), inputElements[inputElements.length-1]);
              }

              var deleteMsgMinLink = document.getElementById('deleteMsgMin');
              if (deleteMsgMinLink)
              {
                  deleteMsgMinLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    var msgMinOrderDiv = document.querySelector('.msg_minimum_order');
                    if (msgMinOrderDiv) {
                      msgMinOrderDiv.parentNode.removeChild(msgMinOrderDiv);
                    }
                  });
              }

              return;
            }
        }


        const QtyProductAdd = document.getElementById("isMinimunQty");
        if(QtyProductAdd)
        {
          if(QtyProductAdd.value !="")
          {
              const pdpQtyInput = document.querySelector('#PDPQuantity .input_container input');
              const QtyIntoProduct = pdpQtyInput ? parseFloat(pdpQtyInput.value) || 0 : 0;
              if(QtyIntoProduct < parseFloat(QtyProductAdd.value))
              {
                const qtyvalueEl3 = document.getElementById("qtyvalue");
                const qtylabelEl3 = document.getElementById("qtylabel");
                if (qtyvalueEl3) qtyvalueEl3.innerHTML = "";
                if (qtylabelEl3) qtylabelEl3.style.display = "none";
                if (pdpQtyInput) pdpQtyInput.classList.remove("changeVariantText");
                
                var inputElements = document.querySelectorAll('.product-form__input');
                var msg_minimum_order = document.querySelectorAll('.msg_minimum_order');

                if(msg_minimum_order.length > 0){return;}

                  var msgMinimumOrder = document.createElement('div');
                  msgMinimumOrder.className = 'msg_minimum_order';
                  msgMinimumOrder.textContent = 'Minimum Order Quantity is '+QtyProductAdd.value;

                var deleteMsgMinLink = document.createElement('a');
                deleteMsgMinLink.href = '#';
                deleteMsgMinLink.id = 'deleteMsgMin';

                msgMinimumOrder.appendChild(deleteMsgMinLink);

                if (inputElements.length > 0) {
                  inputElements[inputElements.length-1].parentNode.insertBefore(msgMinimumOrder.cloneNode(true), inputElements[inputElements.length-1]);
                }

                  var quantityElement = document.querySelector('.product-form__quantity');
                  if (quantityElement) 
                  {
                    var quantityInput = quantityElement.querySelector('quantity-input');
                    if (quantityInput) {
                      quantityInput.classList.add('error_min');
                    }
                  }


                var deleteMsgMinLink = document.getElementById('deleteMsgMin');
                if (deleteMsgMinLink) 
                {
                  deleteMsgMinLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    var msgMinOrderDiv = document.querySelector('.msg_minimum_order');
                    if (msgMinOrderDiv) {
                      msgMinOrderDiv.parentNode.removeChild(msgMinOrderDiv);
                    }
                
                    if (quantityInput) {
                      quantityInput.classList.remove('error_min');
                    }
                  });
                }

                  return;
              }
          }

        }

        var quantityInput = document.querySelector('#PDPQuantity .input_container input');


  
  if( $(document).find('#ProductSubmitButton-template--18793720873123__main').length > 0 ){
    document.getElementById("ProductSubmitButton-template--18793720873123__main").click();
  }

  if( $(document).find('#ProductSubmitButton-template--18810437894307__main').length > 0 ){
    document.getElementById("ProductSubmitButton-template--18810437894307__main").click();
  }
  if( $(document).find('#ProductSubmitButton-template--19223320363171__main').length > 0 ){
    document.getElementById("ProductSubmitButton-template--19223320363171__main").click();
  }

        submitButton.classList.add('loading');
        spinnerDivs.forEach(function (spinnerDiv) 
        {
          spinnerDiv.classList.remove('hidden');
        });
  
        setTimeout(function () 
        {
          submitButton.classList.remove('loading');
          spinnerDivs.forEach(function (spinnerDiv) 
          {
            spinnerDiv.classList.add('hidden');
          });

          setTimeout(function () 
          {
              var cartNotification = document.getElementById('cart-notification');
              if (cartNotification && cartNotification.classList.contains('active')) 
              {
                  window.location.href = "https://shop.expopass.com/cart?v"+generarStringAleatorio(11);
              } 

          }, 1000); 
          
        }, 500); 
}

async function BtnClickSimulator() {
    // Skip Kit products - they have their own handler (KitProductBtnHandler)
    const hasKitClass = document.querySelector('.kit-product') !== null;
    const hasKitUrl = window.location.href.includes('/products/all-in-one-badge-kit');
    const hasEventDate = document.querySelector('[name="properties[Event Start]"]') !== null || document.querySelector('[name="properties[Event End]"]') !== null;
    const isKitProduct = hasKitClass || hasKitUrl || hasEventDate;

    if (isKitProduct) {
        console.log('[BtnClickSimulator] Skipping - Kit product has separate handler');
        return;
    }

    const submitButton = document.getElementById('ProductSubmitButton-template--cs');
    console.log('[BtnClickSimulator] submitButton found:', submitButton);
    if(submitButton != null) {
        submitButton.addEventListener('click', async function () {
            console.log('[BtnClickSimulator] Button clicked!');
            var quantityInput = 1;
            if( $(document).find('#PDPQuantity .input_container input').length > 0 ){
                quantityInput = document.querySelector('#PDPQuantity .input_container input').value;
                document.querySelector('#PDPQuantity .input_container input').classList.add("changeVariantText");
            }

            // Check for date inputs (Event Start and Event End)
            var eventStartInput = $(document).find('[name="properties[Event Start]"]');
            var eventEndInput = $(document).find('[name="properties[Event End]"]');
            if( eventStartInput.length > 0 || eventEndInput.length > 0 ){
              var eventStartVal = eventStartInput.length > 0 ? eventStartInput.val().trim() : '';
              var eventEndVal = eventEndInput.length > 0 ? eventEndInput.val().trim() : '';
              console.log('[BtnClickSimulator] Event Start:', eventStartVal, 'Event End:', eventEndVal);
              if(eventStartVal == '' || eventEndVal == ''){
                console.log('[BtnClickSimulator] Event dates missing - showing warning');

                // Check if warning already exists
                var existingDateWarning = document.querySelector('.msg_date_warning');
                if (existingDateWarning) { return true; }

                var msgDateWarning = document.createElement('div');
                msgDateWarning.className = 'msg_minimum_order msg_date_warning';
                msgDateWarning.innerHTML = 'Please select Event Start and Event End dates. <a href="#" class="msg_close_btn" style="margin-left:10px;color:inherit;font-weight:bold;">✕</a>';

                // Insert above the visible submit button
                var visibleButton = document.getElementById('ProductSubmitButton-template--cs');
                if (visibleButton) {
                    visibleButton.insertAdjacentElement('beforebegin', msgDateWarning);
                }

                // X button to close
                msgDateWarning.querySelector('.msg_close_btn').addEventListener('click', function(e) {
                    e.preventDefault();
                    msgDateWarning.remove();
                });

                // Auto-remove after 10 seconds
                setTimeout(function() {
                    var warning = document.querySelector('.msg_date_warning');
                    if (warning) warning.remove();
                }, 10000);

                return true;
              }
            }

            if( $(document).find('#agree').length > 0 ){
              console.log('[BtnClickSimulator] Agree checkbox checked:', $('#agree').is(':checked'));
              if( $('#agree').is(':checked') == false ){
                console.log('[BtnClickSimulator] Agree not checked - showing warning');
                // Try existing element first, otherwise create dynamic warning
                if ($('#agree-warning').length > 0) {
                  $('#agree-warning').show();
                } else {
                  var existingAgreeWarning = document.querySelector('.msg_agree_warning');
                  if (!existingAgreeWarning) {
                    var agreeWarningMsg = document.createElement('div');
                    agreeWarningMsg.className = 'msg_minimum_order msg_agree_warning';
                    agreeWarningMsg.innerHTML = 'Please agree to the terms to continue. <a href="#" class="msg_close_btn" style="margin-left:10px;color:inherit;font-weight:bold;">✕</a>';
                    var visibleButton = document.getElementById('ProductSubmitButton-template--cs');
                    if (visibleButton) {
                      visibleButton.insertAdjacentElement('beforebegin', agreeWarningMsg);
                    }
                    agreeWarningMsg.querySelector('.msg_close_btn').addEventListener('click', function(e) {
                      e.preventDefault();
                      agreeWarningMsg.remove();
                    });
                    setTimeout(function() {
                      var warning = document.querySelector('.msg_agree_warning');
                      if (warning) warning.remove();
                    }, 10000);
                  }
                }
                return true;
              }
            }
            console.log('[BtnClickSimulator] Validations passed, calling changeSelectVariant');
            var qtyRange = await changeSelectVariant();

            if(typeof qtyRange != 'boolean') {
                quantityInput = qtyRange;
            }

            localStorage.setItem('quantityValue', quantityInput);

          if( $(document).find('#qtyvalue').length > 0 ){
            document.getElementById("qtyvalue").innerHTML = quantityInput;
            document.getElementById("qtylabel").style.display = "block";
          }
            
            console.log('[BtnClickSimulator] Setting 1200ms timeout before ExecOtherCode');
            setTimeout(async function()
            {
                console.log('[BtnClickSimulator] Timeout fired, about to call ExecOtherCode');
                var checkboxes2 = document.querySelectorAll('.avp-productoptionbackground');
                checkboxes2.forEach(async function(checkbox)
                {
                    _this2 = checkbox;
                    if(_this2.value === "Pre-Printed Names")
                    {
                        let FileInputs = document.querySelectorAll("div[data-uploader-id='7d3d35eb-2621-4989-961b-78d07b3e5ef4']");
                        FileInputs.forEach(async function(fileInput)
                        {
                            if(_this2.checked)
                            {
                                await fileInput.style.setProperty('display', 'block', 'important');
                            }
                        });
                    }

                });

                await ExecOtherCode();
                console.log('[BtnClickSimulator] ExecOtherCode completed');
              }, 1200);
            
        });
    }
}

// ========== SEPARATE KIT PRODUCT BUTTON HANDLER ==========
function KitProductBtnHandler() {
    // Multiple ways to detect Kit product
    const hasKitClass = document.querySelector('.kit-product') !== null;
    const hasKitUrl = window.location.href.includes('/products/all-in-one-badge-kit');
    const hasEventDate = document.querySelector('[name="properties[Event Start]"]') !== null || document.querySelector('[name="properties[Event End]"]') !== null;
    const isKitProduct = hasKitClass || hasKitUrl || hasEventDate;

    console.log('[KitProductBtnHandler] Detection - hasKitClass:', hasKitClass, 'hasKitUrl:', hasKitUrl, 'hasEventDate:', hasEventDate);
    if (!isKitProduct) return;

    const submitButton = document.getElementById('ProductSubmitButton-template--cs');
    console.log('[KitProductBtnHandler] Kit product detected, submitButton:', submitButton);

    if (submitButton) {
        submitButton.addEventListener('click', async function(e) {
            console.log('[KitProductBtnHandler] Kit button clicked!');

            // Date validation - MANDATORY (Event Start and Event End)
            const eventStartInput = document.querySelector('[name="properties[Event Start]"]');
            const eventEndInput = document.querySelector('[name="properties[Event End]"]');
            const eventStartVal = eventStartInput ? eventStartInput.value.trim() : '';
            const eventEndVal = eventEndInput ? eventEndInput.value.trim() : '';
            console.log('[KitProductBtnHandler] Event Start:', eventStartVal, 'Event End:', eventEndVal);

            if ((eventStartInput || eventEndInput) && (eventStartVal === '' || eventEndVal === '')) {
                console.log('[KitProductBtnHandler] Event dates missing - showing warning');

                // Check if warning already exists
                var existingDateWarning = document.querySelector('.msg_date_warning');
                if (existingDateWarning) { return; }

                var msgDateWarning = document.createElement('div');
                msgDateWarning.className = 'msg_minimum_order msg_date_warning';
                msgDateWarning.innerHTML = 'Please select Event Start and Event End dates. <a href="#" class="msg_close_btn" style="margin-left:10px;color:inherit;font-weight:bold;">✕</a>';

                // Insert above the visible submit button
                var visibleButton = document.getElementById('ProductSubmitButton-template--cs');
                if (visibleButton) {
                    visibleButton.insertAdjacentElement('beforebegin', msgDateWarning);
                }

                // X button to close
                msgDateWarning.querySelector('.msg_close_btn').addEventListener('click', function(e) {
                    e.preventDefault();
                    msgDateWarning.remove();
                });

                // Auto-remove after 10 seconds
                setTimeout(function() {
                    var warning = document.querySelector('.msg_date_warning');
                    if (warning) warning.remove();
                }, 10000);

                return;
            }

            // Agree checkbox validation
            const agreeCheckbox = document.getElementById('agree');
            if (agreeCheckbox) {
                console.log('[KitProductBtnHandler] Agree checked:', agreeCheckbox.checked);
                if (!agreeCheckbox.checked) {
                    // Remove existing warning if any
                    var existingAgreeWarning = document.querySelector('.msg_agree_warning');
                    if (existingAgreeWarning) { return; }

                    // Create warning message above button
                    var agreeWarningMsg = document.createElement('div');
                    agreeWarningMsg.className = 'msg_minimum_order msg_agree_warning';
                    agreeWarningMsg.innerHTML = 'Please agree to the terms to continue. <a href="#" class="msg_close_btn" style="margin-left:10px;color:inherit;font-weight:bold;">✕</a>';

                    var visibleButton = document.getElementById('ProductSubmitButton-template--cs');
                    if (visibleButton) {
                        visibleButton.insertAdjacentElement('beforebegin', agreeWarningMsg);
                    }

                    // X button to close
                    agreeWarningMsg.querySelector('.msg_close_btn').addEventListener('click', function(e) {
                        e.preventDefault();
                        agreeWarningMsg.remove();
                    });

                    // Auto-remove after 10 seconds
                    setTimeout(function() {
                        var warning = document.querySelector('.msg_agree_warning');
                        if (warning) warning.remove();
                    }, 10000);

                    console.log('[KitProductBtnHandler] Agree not checked - showing warning');
                    return;
                }
            }

            // Upload check - ONLY required for Full Color variant
            const uploadBlock = document.querySelector('[id*="file_uploads_by_uploadkit_app_block"]');
            const existsFile = document.querySelector('.uploadkit-button-uploaded');
            // Check if uploadkit block is visible (not hidden by CSS/JS for Black & White variants)
            const isUploadVisible = uploadBlock && window.getComputedStyle(uploadBlock).display !== 'none';
            const isUploadRequired = document.querySelectorAll('input#upload_required').length > 0;
            console.log('[KitProductBtnHandler] Upload visible:', isUploadVisible, 'uploadBlock:', uploadBlock, 'Uploaded file:', existsFile);

            // Only validate upload if the upload block is visible (Full Color selected)
            if (isUploadRequired && isUploadVisible && existsFile == null) {
                console.log('[KitProductBtnHandler] No file uploaded - showing error');
                var existingUploadWarning = document.querySelector('.msg_upload_warning');
                if (existingUploadWarning) { return; }

                var msgMinimumOrder = document.createElement('div');
                msgMinimumOrder.className = 'msg_minimum_order msg_upload_warning';
                msgMinimumOrder.innerHTML = window.UploadKit.config.uploaders[0].requiredMessage + ' <a href="#" class="msg_close_btn" style="margin-left:10px;color:inherit;font-weight:bold;">✕</a>';

                // For Kit products, insert above the visible submit button
                var visibleButton = document.getElementById('ProductSubmitButton-template--cs');
                if (visibleButton) {
                    visibleButton.insertAdjacentElement('beforebegin', msgMinimumOrder);
                }

                // X button to close
                msgMinimumOrder.querySelector('.msg_close_btn').addEventListener('click', function(e) {
                    e.preventDefault();
                    msgMinimumOrder.remove();
                });

                // Auto-remove after 10 seconds
                setTimeout(function() {
                    var warning = document.querySelector('.msg_upload_warning');
                    if (warning) warning.remove();
                }, 10000);

                return;
            }

            // All validations passed - submit form
            console.log('[KitProductBtnHandler] All validations passed - submitting form');
            const spinnerDivs = document.querySelectorAll('.loading-overlay__spinner');

            // Show loading state
            submitButton.classList.add('loading');
            spinnerDivs.forEach(function(spinnerDiv) {
                spinnerDiv.classList.remove('hidden');
            });

            // Submit the form directly
            const productForm = document.querySelector('product-form form');
            console.log('[KitProductBtnHandler] Product form:', productForm);
            if (productForm) {
                productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }

            // Remove loading state after delay
            setTimeout(function() {
                submitButton.classList.remove('loading');
                spinnerDivs.forEach(function(spinnerDiv) {
                    spinnerDiv.classList.add('hidden');
                });
            }, 500);
        });
    }
}

// Call KitProductBtnHandler on DOMContentLoaded
document.addEventListener('DOMContentLoaded', KitProductBtnHandler);
// ========== END KIT PRODUCT BUTTON HANDLER ==========

async function removeComas(cadena) 
{
  if(cadena.indexOf(",") > -1)
  {
    return cadena.replace(/,/g, '');  
  }
  return cadena.replace(",", "");
}

async function changeSelectVariant()
{
      var quantityInput = document.querySelector('#PDPQuantity .input_container input');
      //var selectElement = document.getElementById('Option-template--18793720873123__main-0');
      var selectElement = document.querySelector('select[name="options[Volume Price]"]');
      var form = $("[id^='product-form-template--']");

      // Check if quantityInput exists before accessing value (Kit products don't have this)
      if( quantityInput == null || selectElement == null ){
        return true;
      }

      var quantity = parseInt(quantityInput.value, 10);

      var options = selectElement.options; 
      var selected = false;
      var maxRange = 0; 

        var outOfRange = true;
        for (var i = 0; i < options.length; i++) {
            var option = options[i];
            var option2 = options[i];

            if(option2.value.indexOf("+") > -1)
            {
                var range = option2.value.split('+');

                var min = parseInt(await removeComas(range[0]), 10);
                var max = parseInt("1000000");                        
            }
            else{
                var range = option2.value.split('-');

                var min = parseInt(await removeComas(range[0]), 10);
                var max = parseInt(await removeComas(range[1]), 10);
            }

            if (quantity >= min && quantity <= max) {
                selectElement.value = option.value;
                var changeEvent = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(changeEvent);
                selected = true; 
                break;
            }
          
            if (max > maxRange) {
                maxRange = max;
            }
        }

        
        if (!selected && quantity > maxRange) 
        {
            selectElement.value = options[options.length - 1].value;
            var changeEvent = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(changeEvent);
            return maxRange;
        }
        
    return true;
}

const selectElement = document.querySelector('select[name="options[Volume Price]"]');
if (selectElement) 
{
  const secondParentElement = selectElement.parentElement.parentElement;
  secondParentElement.classList.add('esconderselect');
}


/*Animation on mobile*/
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (rect.top <= windowHeight / 2 && rect.bottom >= windowHeight / 2);
}

function handleScroll() {
    // Verificar si el ancho de la pantalla es menor o igual a 768 píxeles (puedes ajustar este valor según tus necesidades)
    if (window.innerWidth <= 768) {
        const products = document.querySelectorAll('#shopify-section-template--17192298315939__product-grid .grid__item');
        const products2 = document.querySelectorAll('#shopify-section-template--17192298315939__24e35500-7ccb-42e2-aa12-3c93a5d49800 .grid__item');
        const products3 = document.querySelectorAll('#shopify-section-template--17192298315939__35fc9e0d-f115-4cb8-b7fb-a3501a5878ad .grid__item');
      
        products.forEach((product) => {
            if (isElementInViewport(product)) {
                product.classList.add('activeanimation');
            } else {
                product.classList.remove('activeanimation');
            }
        });
        products2.forEach((product) => {
            if (isElementInViewport(product)) {
                product.classList.add('activeanimation');
            } else {
                product.classList.remove('activeanimation');
            }
        });
        products3.forEach((product__) => {
            if (isElementInViewport(product__)) {
                product__.classList.add('activeanimation');
            } else {
                product__.classList.remove('activeanimation');
            }
        });

      
    }
}

window.addEventListener('scroll', handleScroll);
document.addEventListener('DOMContentLoaded', handleScroll);

/*Shop All*/
var priceSpans = document.querySelectorAll('#shopify-section-template--19872002244902__35fc9e0d-f115-4cb8-b7fb-a3501a5878ad .price-item--regular');
priceSpans.forEach(function(span) {
    span.textContent = 'Various Color Options';
});

if (window.location.href === "https://shop.expopass.com/products/4x6-paper-event-badge-double-sided") {
  window.location.href = "https://shop.expopass.com/products/4-x-6-paper-event-badge-double-sided-no-notch";
}
if (window.location.href === "https://shop.expopass.com/products/4x6-paper-event-badge-single-sided") {
  window.location.href = "https://shop.expopass.com/products/4-x-6-paper-event-badge-single-sided-no-notch";
}
if (window.location.href === "https://shop.expopass.com/products/4x3-paper-event-badge-double-sided") {
  window.location.href = "https://shop.expopass.com/products/4-x-3-paper-event-badge-double-sided-no-notch";
}
if (window.location.href === "https://shop.expopass.com/products/4x3-paper-event-badge-single-sided") {
  window.location.href = "https://shop.expopass.com/products/4-x-3-paper-event-badge-single-sided-no-notch";
}
if (window.location.href === "https://shop.expopass.com/products/4x6-plastic-event-badge-double-sided") {
  window.location.href = "https://shop.expopass.com/products/4-x-6-plastic-event-badge-double-sided-single-notch";
}

function redirectToProduct(productUrl) {
  window.location.href = productUrl;
}


document.addEventListener("DOMContentLoaded", function () 
{

  setTimeout(function()
  {
      var enlaces = document.querySelectorAll('a[href="/cart"]');
      var numeroAleatorio = new Date().getTime();
      enlaces.forEach(function(enlace) 
      {
        enlace.setAttribute('href', '/cart?v' + numeroAleatorio);
      });
  }, 1000);
  
  function trackAjaxRequests() {
      var open = XMLHttpRequest.prototype.open;
      var send = XMLHttpRequest.prototype.send;
  
      XMLHttpRequest.prototype.open = function () {
          activeAjaxRequests++;
          return open.apply(this, arguments);
      };
  
      XMLHttpRequest.prototype.send = function () {
          var self = this;
          this.addEventListener("load", function () {
              if (self.readyState === 4) {
                  activeAjaxRequests--;
                  if (activeAjaxRequests === 0) {
                      console.log("No hay solicitudes AJAX en curso.");
                  }
              }
          });
          return send.apply(this, arguments);
      };
  }
  
  trackAjaxRequests();
  
  //Controlar si existe cupon o no.
  function checkAndHandleClick() 
  {
    console.log("Entro 1", activeAjaxRequests);
    trackAjaxRequests();
    console.log("Entro 2", activeAjaxRequests);
    if (activeAjaxRequests === 1) 
    {
      waitForAjaxComplete();
    }
    else 
    {
      console.log("Llamo a check", activeAjaxRequests);
      checkOKMessage();
    }
  }
  
  function waitForAjaxComplete() {
    if (activeAjaxRequests === 0) {
      checkOKMessage();
    } else {
      setTimeout(waitForAjaxComplete, 100);
    }
  }

  function ResetDesign()
  {
      var successMessage = document.querySelector('.msg.success');
      
      if (successMessage) 
      {
        var strongElements = successMessage.querySelectorAll('strong');
        var PriceDiscount = strongElements[0].textContent;
        if (strongElements.length >= 2) 
        {
          var secondStrongText = strongElements[1].textContent.toUpperCase();
      
          var removeLink = document.createElement('a');
          removeLink.textContent = 'Remove';
          removeLink.id = 'RemoveCupon';
          removeLink.href = '#remove';
      
          var appliedText = document.createTextNode(' Applied.');
      
          strongElements[1].innerHTML = '';
      
          var newStrongElement = document.createElement('strong');
          newStrongElement.textContent = secondStrongText + ' Applied.';
      
          successMessage.innerHTML = ''; 
          successMessage.appendChild(newStrongElement);
          successMessage.appendChild(removeLink); 

          removeCupon();
        }

        SubTotalQueda = 0;
        var element = document.querySelector('.totals__subtotal-value.sc-qb-cart-auto-ad-subtotal-2017210342');
        if (element) 
        {
          var SubTotalInicial = parseFloat(element.innerHTML.replace("$","").replace(",",""));
          var DiscountCupon = parseFloat(PriceDiscount.replace("$","").replace(",",""));

          SubTotalQueda = SubTotalInicial - DiscountCupon;
          SubTotalQueda = SubTotalQueda.toFixed(2);
          SubTotalQueda = SubTotalQueda.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        var firstDiv = document.createElement('div');
        firstDiv.className = 'totals';
        
        var firstH2 = document.createElement('h2');
        firstH2.className = 'totals__cupon';
        firstH2.textContent = secondStrongText;

        var subtotalElement = document.querySelector('.sc-qb-cart-auto-ad-subtotal-2017210342');
        if (subtotalElement) {
          subtotalElement.classList.add('newsubtotal');
        }

        
        var firstP = document.createElement('p');
        firstP.className = 'totals__subtotal-value';
        firstP.textContent = '-'+PriceDiscount;
        
        firstDiv.appendChild(firstH2);
        firstDiv.appendChild(firstP);
        
        var secondDiv = document.createElement('div');
        secondDiv.className = 'totals';
        
        var secondH2 = document.createElement('h2');
        secondH2.className = 'totals__subtotal';
        secondH2.textContent = 'Subtotal';
        
        var secondP = document.createElement('p');
        secondP.className = 'totals__subtotal-value';
        secondP.textContent = '$'+SubTotalQueda;
        
        secondDiv.appendChild(secondH2);
        secondDiv.appendChild(secondP);
        
        var totalsElement = document.querySelector('.totals');
        
        if (totalsElement) {
            totalsElement.parentNode.insertBefore(secondDiv, totalsElement.nextSibling);
            totalsElement.parentNode.insertBefore(firstDiv, totalsElement.nextSibling);
        }

      }
  }
  
  
  function checkOKMessage() 
  {
    console.log("Validando");
    var discountInput = document.querySelector('[name="discount"]');
    if(discountInput.value == "REMOVECUPON")
    {
        location.reload()
    }
    else
    {
      var errorMessages = document.querySelectorAll('.msg.success');
      var discountInputGroup = document.querySelector('.sc-qb-discount-input-group');
  
      var elementsClass = document.querySelectorAll('.HiddenElement');
      if(elementsClass){
        for (var i = 0; i < elementsClass.length; i++) 
        {
          elementsClass[i].classList.remove('HiddenElement');
        }  
      }
      
      if (errorMessages.length > 0) 
      {
        discountInputGroup.classList.add('HiddenElement'); 
        ResetDesign();
      }  
    }
    
  }

  function addClickHandler() 
  {
    var button = document.querySelector('span.sc-qb-discount-input-group-btn button');
    if (button) {
      button.addEventListener('click', function () {
        setTimeout(checkAndHandleClick, 500);
      });
    }
  }

  function removeCupon()
  {
      var removeLink = document.getElementById('RemoveCupon');
      
      if (removeLink) 
      {
        removeLink.addEventListener('click', function (event) 
        {
          event.preventDefault();
          console.log("Remove Cupon");
          var discountInput = document.querySelector('[name="discount"]');
          if (discountInput) {
            discountInput.value = 'REMOVECUPON';
          }
      
          var discountButton = document.querySelector('.sc-qb-discount-input-group-btn button');
          if (discountButton) 
          {
              discountButton.click();
              setTimeout(checkOKMessage, 2000);
          }
        });
      }
    
  }
  
  var PageCart = document.querySelector('.your_shopping_cart');
  if(PageCart)
  {
      localStorage.removeItem('80174-dismissed-in-session');
    
      var elemento = document.getElementById('app-embed-container-80174');
      if (elemento) {
        elemento.setAttribute('style', 'display:none !important');
      }  

      var interval = setInterval(function () 
      {
        var button = document.querySelector('span.sc-qb-discount-input-group-btn button');
        if (button) 
        {
          clearInterval(interval);
          addClickHandler();
          removeCupon();
          checkOKMessage();
        }
      }, 500);   

      var isSent = localStorage.getItem('80174-dismissed-after-submit');

      if(!isSent)
      {
          var intervalCartAbandoned = setInterval(function () 
          {
            var buttonCartAbd = document.getElementById('app-embed-container-80174');
            
                if (buttonCartAbd) 
                {
                  var elemento = document.getElementById('app-embed-container-80174');
                  if (elemento) {
                    elemento.setAttribute('style', 'display:none !important');
                  } 
        
                  setTimeout(function()
                  {
                    var elemento2 = document.getElementById('app-embed-container-80174');
                    if(elemento2.getAttribute("style") == "display:none !important")
                    {
                        clearInterval(intervalCartAbandoned);    
                    }
                    
                  }, 150);
                  
                }  
            
            
          }, 100);   
      }
        

      document.addEventListener('click', function(event) 
      {
          var isSent = localStorage.getItem('80174-dismissed-after-submit');

          if(!isSent)
          {
              var elementoClicado = event.target;
    
              while (elementoClicado && elementoClicado.tagName !== 'A') {
                elementoClicado = elementoClicado.parentNode;
              }
    
              if (elementoClicado && elementoClicado.getAttribute('href')) {
                  
                  var destino = elementoClicado.getAttribute('href');
                  var urlActual = window.location.pathname;
                  console.log("****", destino);
    
                  let isClosed = localStorage.getItem('80174-dismissed-in-session');
                    
                  if(!isClosed && !document.querySelector('.icon-cart-empty'))
                  {
                    //TEMP ABANDONED
                    //event.preventDefault();
      
                    var elemento = document.getElementById('app-embed-container-80174');
                    if (elemento) {
                      //TEMP ABANDONED
                      //elemento.setAttribute('style', 'display:block !important;visibility:visible !important;');
                    }  
                  }


                  //Refrescar AddOn
                  if(destino.includes("cart/change"))
                  {
                      let IntevalCarrito = setInterval(function()
                      {
                            const cartItemTotals = document.querySelectorAll('.cart-item__totals');
                            let loadingOverlayCount = 0;
                            let hiddenLoadingOverlayCount = 0;
                            
                            cartItemTotals.forEach(cartItemTotal => 
                            {                            
                                const loadingOverlays = cartItemTotal.querySelectorAll('.loading-overlay');
                                loadingOverlayCount += loadingOverlays.length;
                            
                                const hiddenLoadingOverlays = cartItemTotal.querySelectorAll('.loading-overlay.hidden');
                                hiddenLoadingOverlayCount += hiddenLoadingOverlays.length;
                            });
                            
                            if(loadingOverlayCount == hiddenLoadingOverlayCount)
                            {
                               console.log("Clear Cart");
                               clearInterval(IntevalCarrito); 

                               /* Exec Cart */
                              var cloneAddonRows = document.querySelectorAll('tr[data-cloneaddon]');

                              if (document.querySelector('.clonado_nuevo')) 
                              {
                                  console.log('Ya están sus AddOn');
                              } 
                              else
                              {

                                if (cloneAddonRows) 
                                {
                                    cloneAddonRows.forEach(function(cloneAddonRow) {
                                      var cloneAddonValue = cloneAddonRow.getAttribute('data-cloneaddon');
                                      
                                      var qtyTr = cloneAddonRow.previousElementSibling;
                                      while (qtyTr && !qtyTr.id) {
                                        qtyTr = qtyTr.previousElementSibling;
                                      }
                                
                                      var qtyInput = qtyTr ? qtyTr.querySelector('.quantity__input') : null;
                                      var qtyValue = qtyInput ? parseFloat(qtyInput.value) : 0;
                                      
                                      var targetTd = document.querySelector('td[data-idaddon="' + cloneAddonValue + '"]');
                                      
                                      if (targetTd) {      
                                        var targetTr = targetTd.closest('tr');
                                        
                                        if (targetTr) 
                                        {
                                          targetTr.classList.add('encontrado_usado');
                                
                                          var clonedTr = targetTr.cloneNode(true);
                                
                                          clonedTr.removeAttribute('id');
                                          clonedTr.classList.remove('encontrado_usado');
                                          clonedTr.classList.add('clonado_nuevo');
                                          
                                          var clonedTd = clonedTr.querySelector('td[data-idaddon]');
                                          if (clonedTd) {
                                            clonedTd.removeAttribute('data-idaddon');
                                          }
                                          
                                          Array.from(clonedTr.attributes).forEach(function(attr) {
                                            if (attr.name.startsWith('data-')) {
                                              clonedTr.removeAttribute(attr.name);
                                            }
                                          });
                                
                                          var dlNode = clonedTr.querySelector('dl');
                                          if (dlNode) {
                                            var productOptionHtml = `
                                              <div class="product-option 222">
                                                <dt>✓</dt>                            
                                                <dd>Quantity: ${qtyValue}</dd>
                                              </div>`;
                                            dlNode.insertAdjacentHTML('beforeend', productOptionHtml);
                                          }
                                
                                          var originalPriceElement = clonedTr.querySelector('.avisplus-cart-item-original-price');
                                          var linePriceElements = clonedTr.querySelectorAll('.avisplus-cart-item-line-price');
                                
                                          if (originalPriceElement && linePriceElements.length > 0) {
                                            var originalPriceText = originalPriceElement.textContent.trim();            
                                            var originalPrice = parseFloat(originalPriceText.replace('$', ''));            
                                            var newLinePrice = (originalPrice * qtyValue).toFixed(2);
                                            
                                            linePriceElements.forEach(function(linePriceElement) {
                                              linePriceElement.textContent = `$${newLinePrice}`;
                                            });
                                          }
                                
                                          cloneAddonRow.parentNode.insertBefore(clonedTr, cloneAddonRow.nextSibling);
                                        }
                                      }
                                    });
                                  }
                              }
                              
                               /* End Exec Cart */
                            }
                            
                      }, 200);
                  }
                  
              }  
          }
          
        
          
      });
  }


  function LoadCssEmbed()
  {
      var formEmbed = document.getElementById('app-embed');
      var shadow = formEmbed.shadowRoot; 

      var style = document.createElement('style');
      style.textContent = `
           h2{display:none}

           div div div section section div form div input
           {
              margin-left: 0!important;
              text-align: left!important;
              font-family: "Open Sans", sans-serif !important;
              font-size: 1.1em!important;
              height: 2.5em!important;
              min-height: inherit!important;
              letter-spacing: 0!important;
              background: none !important;
              border: none !important;
              border-bottom: 1px solid #C3BFB8!important;
              outline: none !important;
              box-shadow: none !important;
              border-radius: 0 !important;
              padding: 0 !important;
              padding-top: 1.5em !important;
           }
           div div div section section div form div:nth-child(9) {
                  margin-top: 1.3em;
              }
           div div div section section div form div label
           {
                text-align: left!important;
                font-family: "Open Sans", sans-serif !important;
                font-size: 1.2em!important;
                padding-left: 0!important;
                left: 0!important;
                margin-left: 0!important;
                color: #1f1922!important;
                letter-spacing: 0!important;
                position: absolute !important;
                top: calc(1rem + var(--inputs-border-width)) !important;
           }
           div div div section section[data-testid="form-container"]
           {
                width: 60em !important;
                max-width: inherit !important;
           }
           
           div div div section section div form div
           {
              width: 48% !important;  
              margin-bottom: 0.5em !important;
          }
          div div div section section div form
          {
              display: flex !important;
              flex-flow: wrap !important;
              justify-content: space-between !important;
          }
          section section div form button[data-testid="btn-form-submit"]
          {
                border-radius: 3em !important;
                border: 0.1875em solid #1f1922 !important;
                outline: 0 none !important;
                color: #1f1922 !important;
                font-size: 1.225em !important;
                font-family: "Open Sans" !important;
                padding: 0.7em 3.4em !important;
                text-decoration: none !important;
                width: auto !important;
                min-width: inherit !important;
                cursor: pointer !important;
                display: table !important;
                margin: 0 auto !important;
                background: #fcf260 !important;
                transition: all .3s ease-in-out !important;  
                margin-top: 1.5em !important;
          }
          
          section section div form button[data-testid="btn-form-submit"]:hover 
          {
                background: #1f1922!important;
                color: #f9f5ef!important;
          }
          div div div section section div form div:nth-child(3) ,
          div div div section section div form div:nth-child(4)
          {
               width:100% !important;
          }
          div div div section section div form div:nth-child(6)
          {
               width:15% !important;
          }
          div div div section section div form div:nth-child(7)
          {
               width:30% !important;
          }
          div div div section section div form div:nth-child(9)
          {
               width:100% !important;
          }
          
          div div div section section div form div:nth-child(9) button
          {
               margin-left: 0 !important;
              text-align: left !important;
              font-family: "Open Sans", sans-serif !important;
              font-size: 1.1em !important;
              height: 2.5em !important;
              min-height: inherit !important;
              letter-spacing: 0 !important;
              background: none !important;
              border: none !important;
              border-bottom: 1px solid #C3BFB8 !important;
              outline: none !important;
              box-shadow: none !important;
              border-radius: 0 !important;
              padding: 0 !important;
              padding-top: 0.5em !important;
              max-height: inherit !important;
          }
          div div div section section div form div:nth-child(9) p
          {
                font-family: "Open Sans", sans-serif !important;
                font-size: 1.2em !important;
                margin-bottom: 0.35em !important;
          }

          div div div section section div form div:nth-child(9) button div
          {
              width: 99% !important;
          }
          
          ._formError_z7chr_20 
          {
              width: 100%;
          }
           div._withError_z7chr_16
          {
              width: 100% !important;
              min-width: 100% !important;
          }
          
          
          ._formBannerContainer_1t76a_1 
          {
                 background: #DAE6D4;
                color: #3D9A44;
                width: 30em;
                margin: 0 auto !important;
                border: 1px solid #3D9A44;
                padding: 2em 1.25em;
                text-align: left !important;
          }    
          ._formBannerContainer_1t76a_1 p
          {
                font-family: "Open Sans";
                font-size: 1em;
                position:relative;
          }
          ._formBannerContainer_1t76a_1 p:before
          {
                content:"";
                width:1.75em;
                height:1.5em;
                background: url(https://cdn.shopify.com/s/files/1/0747/8440/7846/files/button_close_confirmation.svg?v=1699478430);
                background-repeat: no-repeat;
                background-position: center;
                position:absolute;
                right:0;
                cursor: pointer;
          }
         ._formBannerContainer_1t76a_1 h2 
          {
              display:none !important;
          }
          ._formError_1oy4y_20 + div 
          {
              width: 100% !important;
              min-width: 100% !important;
          }
          ._formFieldContainer_z7chr_5:nth-child(3) ,
          ._formFieldContainer_z7chr_5:nth-child(8)
          {
                  width: 100%!important;
           }

           div div div section section div form output,
           div div div section section div form div[class*="_withError_"],
           button[class*="_selectorError"] div,
           ._selectContainer_1yit2_6
           {
              width: 100% !important;
           }
           
           /*
           div div div section section div form div:nth-child(1)[class*="_withError_"] + output + div
           {
               width: 48% !important;
           }
           div div div section section div form div:nth-child(2)[class*="_withError_"] + output + div
           {
               width:100% !important;
           }*/


          /* div div div section section div form div[class*="_withError_"]:after
           {
               content: "Field is required";
               color: #e02229;
              font: normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif;
              bottom: -4px;
              position: relative;
           }*/
 
          @media screen and (max-width: 760px) 
          {
              ._inline_whyqz_45 ._formContainer_whyqz_30 
              {
                  max-width: 90% !important;
              }
              ._formBannerContainer_1t76a_1 
              {
                  width: 25em;
              }
              
              div div div section section div form
              {
                  width: 100%!important;
              }
              div div div section section div form div
              {
                  width: 100%!important;
              }

              div div div section section[data-testid="form-container"]
             {
                  width: 100% !important;
                  max-width: inherit !important;
             }

             div div div section section div form div:nth-child(6),
             div div div section section div form div:nth-child(7)
             {
                 width: 48% !important;
             }
              
          }
          
      `;

      shadow.appendChild(style);
    
   }

  var embed = document.getElementById('shopify-section-template--21474910470438__16994350543a85ebb5');
  if(embed)
  {
      var intervalEmbed = setInterval(function () 
      {
        var embedReal = document.getElementById('app-embed');
        if (embedReal) 
        {
          clearInterval(intervalEmbed);
          LoadCssEmbed();
        }
      }, 100);   
  }

  
  function LoadCssNewsLetterFooter()
  {
      var formEmbed = document.querySelector('footer #app-embed');
      var shadow = formEmbed.shadowRoot; 

      var style = document.createElement('style');
      style.textContent = `
          div div div section section div section > div > p
          {
              font-family: "Open Sans", sans-serif;
              font-size: 0.875em;
              color: #fff;
              opacity: 50%;
              text-align: left;
          }
          input[data-testid="field-email"]
           {
              background: none !important;
              color: #fff !important;
              border: 1px solid #969491 !important;
              border-radius: 5em !important;
              outline: none !important;
              box-shadow: none !important;
              padding-right: 5em !important;
              padding-left: 1.5em !important;
          }
          form label[id="label-email"]
          {
              color: #686868 !important; 
              font-family: "Open Sans", sans-serif !important;
              padding-left:8px;
          }
          button[data-testid="btn-form-submit"]
          {
              width: 4em !important;
              position: absolute !important;
              right: 1em !important;
              color: transparent !important;
              bottom: 0em !important;
              padding: 0 !important;
              height: 3.5em !important;
              cursor: pointer !important;
              background: url( https://cdn.shopify.com/s/files/1/0747/8440/7846/files/icon_arrow_newletter.svg?v=1699488735) !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              background-size: 1.3em !important;
              top: 5em !important;
          }
          section._formHeader_16kdc_19 
          {
              margin: 0px auto 1.5em !important;
          }

         section section[data-testid="form-container"]
         {
            position: relative;
         }

         form._formFieldset_1ll8d_67
             {
                 position:relative;  
             }
             
             button._formSubmitButton_1ll8d_81 
             {
                top: 0 !important;
              }

         @media screen and (max-width: 375px) 
         {
             
         }
      `;

      shadow.appendChild(style);


      var scriptN = document.createElement('script');
      scriptN.textContent = `
        var formEmbed = document.querySelector('footer #app-embed');
        
        if (formEmbed && formEmbed.shadowRoot) 
        {
            var submitButton = formEmbed.shadowRoot.querySelector('button[data-testid="btn-form-submit"]');

            if (submitButton) {
              submitButton.addEventListener('click', function() 
              {
                var intervalId = setInterval(function() {
                  
                  var error = formEmbed.shadowRoot.querySelector('output[role="alert"]');
                  if (error) {
                    
                    clearInterval(intervalId);
                  } else {
                    
                    var successBanner = formEmbed.shadowRoot.querySelector('section[data-testid="banner-success"] h2');
                    if (successBanner && successBanner.innerHTML.includes('Successful message')) 
                    {
                      window.location.href = 'https://www.billysbadges.com/pages/thanks-for-subscribing';
                      clearInterval(intervalId);
                    }
                  }
                }, 100); 
          
              });
            }    
        }
        
        
        var formEmbed2 = document.querySelector('#shopify-section-sections--19872002998566__1699503056442a3f3f #app-embed');
        
        if (formEmbed2 && formEmbed2.shadowRoot) 
        {
            var submitButton = formEmbed2.shadowRoot.querySelector('button[data-testid="btn-form-submit"]');

            if (submitButton) {
              submitButton.addEventListener('click', function() 
              {
                var intervalId = setInterval(function() {
                  
                  var error = formEmbed2.shadowRoot.querySelector('._formError_1oy4y_20');
                  if (error) {
                    
                    clearInterval(intervalId);
                  } else {
                    
                    var successBanner = formEmbed2.shadowRoot.querySelector('section[data-testid="banner-success"] h2');
                    if (successBanner && successBanner.innerHTML.includes('Successful message')) 
                    {
                      setCookieNews = function(name, value, days) {
                        var expires = "";
                        if (days) {
                          var date = new Date();
                          date.setTime(date.getTime() + (days*24*60*60*1000));
                          expires = "; expires=" + date.toUTCString();
                        }
                        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
                      }
                      setCookieNews("popupHidden1", 'true',3); // La cookie dura 7 días
                      window.location.href = 'https://www.billysbadges.com/pages/thanks-for-subscribing';
                      clearInterval(intervalId);
                    }
                  }
                }, 100); 
          
              });
            }    
        }
      `;
      setTimeout(function(){
        shadow.appendChild(scriptN);  
      }, 2000);


      var formSample = document.querySelector('#shopify-block-b894986c-70b0-4684-8ad1-bd35005b1faf #app-embed');
      if(formSample)
      {
          var shadowSample = formSample.shadowRoot;  

          var scriptN = document.createElement('script');
          scriptN.textContent = `            
            var formEmbed2 = document.querySelector('#shopify-block-b894986c-70b0-4684-8ad1-bd35005b1faf #app-embed');
            
            if (formEmbed2 && formEmbed2.shadowRoot) 
            {
                var submitButtonSample = formEmbed2.shadowRoot.querySelector('._formSubmitButton_g1wk8_82');
    
                if (submitButtonSample) {
                  submitButtonSample.addEventListener('click', function() 
                  {
                    var intervalId = setInterval(function() {
                      
                      var successSend = formEmbed2.shadowRoot.querySelector('._formBannerContainer_1t76a_1');
                      if (successSend) 
                      {
                          clearInterval(intervalId);
                          var CloseClick = formEmbed2.shadowRoot.querySelector('._formBannerContainer_1t76a_1 p');
                          CloseClick.addEventListener('click', function() 
                          {
                              window.location.reload();
                          });
                      }
                    }, 100); 
              
                  });
                }    
            }
          `;
          setTimeout(function(){
            shadow.appendChild(scriptN);  
          }, 2000);
      }
      
      
   }
  
  var intervalEmbedFooter = setInterval(function () 
  {
    var embedRealFooter = document.querySelector('footer #app-embed');
    if (embedRealFooter) 
    {
      clearInterval(intervalEmbedFooter);
      LoadCssNewsLetterFooter();
    }
  }, 100); 
  
  document.addEventListener("DOMContentLoaded", function() {
    var gridItem = document.querySelector("._gridItem_1qy88_169");

    if(gridItem)
    {
        gridItem.addEventListener("click", function() {
          window.location.reload();
        });  
    }
    
  });




  
  var thanks_for_your_order = document.querySelector('.thanks_for_your_order');
  if (thanks_for_your_order && location.hash !="") 
  {
       document.querySelector('#shopify-section-template--21476950573350__260e6042-6f8b-42c7-b0bb-322b45dc1a38 h3 strong').innerHTML = 'Order '+location.hash;
  }

  
  var detail_product_main = document.querySelector('.detail_product_main');
  if(detail_product_main)
  {
      var intervalDP = setInterval(function () 
      {
        var QtyValueProd = document.querySelector('#PDPQuantity .input_container input');
        if (QtyValueProd) 
        {
          clearInterval(intervalDP);
          if( $(document).find('#PDPQuantity').length > 0 && $(document).find('#PDPQuantity').hasClass('kit-product') ){
            document.querySelector('#PDPQuantity .input_container input').value = 1
          }else{
            document.querySelector('#PDPQuantity .input_container input').value = 100
          }
          
        }
      }, 100);   
  }


  
  var detail_product_main2 = document.querySelector('.detail_product_main');
  if (detail_product_main2) {
    var intervalDP2 = setInterval(function () {
      var SubAddOns = document.querySelector('.custom_product_subpro');
      if (SubAddOns || true) {
        clearInterval(intervalDP2);
  
        var checkboxes = document.querySelectorAll('.avp-productoptionbackground');
        var onCheckboxClick = function() {
          let FileInputs = document.querySelectorAll("div[data-uploader-id='7d3d35eb-2621-4989-961b-78d07b3e5ef4']");
          _this = this;
          console.log(_this.value)
            if(_this.value === "Pre-Printed Names")
            {
                FileInputs.forEach(function(fileInput) 
                {
                    if(_this.checked) 
                    {
                          fileInput.style.setProperty('display', 'block', 'important');
                    } else {
                          fileInput.style.setProperty('display', 'none', 'important');
                    }
                }); 
            }
        };
  
        checkboxes.forEach(function(checkbox) {
            checkbox.addEventListener('click', onCheckboxClick);
        });
        
      }
    }, 100);
  }
/*
    var targetDiv = document.getElementById('f1f2b1f0-2f86-47ec-8a6d-3084a09a100e');

    var newImage = document.createElement('img');
    newImage.src = window.newslettersVar.imageNewsletter;
    newImage.alt = window.newslettersVar.titleNewsletter;
    newImage.width = "700";
    newImage.height = "323";
    newImage.style.width = "100%";
    newImage.style.height = "auto";
    
    targetDiv.appendChild(newImage);
    
    var dataPopupDiv = document.createElement('div');
    dataPopupDiv.className = 'data-popup2';

    var dataPopupDiv2 = document.createElement('div');
    dataPopupDiv2.className = 'button-popup-new';
  
    
    var h3 = document.createElement('h3');
    h3.textContent = window.newslettersVar.titleNewsletter;
    
    dataPopupDiv.appendChild(h3);
    
    var textPopupDiv = document.createElement('div');
    textPopupDiv.className = 'text-popup';
    
    var p = document.createElement('p');
    p.innerHTML = window.newslettersVar.bodyNewsletter;
    
    textPopupDiv.appendChild(p);    
    dataPopupDiv.appendChild(textPopupDiv);
    targetDiv.appendChild(dataPopupDiv2);
    targetDiv.appendChild(dataPopupDiv);
  
      
    function LoadCssNewsLetterPopup()
    {
        var formEmbed = document.querySelector('#f1f2b1f0-2f86-47ec-8a6d-3084a09a100e #app-embed');
        var shadow = formEmbed.shadowRoot; 
  
        var style = document.createElement('style');
        style.textContent = `

          ._inline_whyqz_45 {
              justify-content: flex-start;
              padding-left: 3em;
          }
            ._textBody_2aowh_10 p
            {
                display:none !important;
            }
            ._formInputField_237zm_7
             {
                background:none !important;
                border: 1px solid #969491 !important;
                border-radius: 5em !important;
                outline: none !important;
                box-shadow: none !important;
                padding-right: 5em !important; 
                color: #686868 !important; 
                font-family: "Open Sans", sans-serif !important;
                padding-left: 1.75em !important;
            }
            ._formSubmitButton_16kdc_81
            {
                 font-weight: bold !important;
                  font-family: "Open Sans" !important;
                  border-radius: 27px !important;
                  width: 10em !important;
                  background:#fcf260 !important;
                  color:#000 !important;  
                  line-height: initial !important;
            }
            section._formHeader_16kdc_19 
            {
                margin: 0px auto 1.5em !important;
            }
            ._formInputFieldLabel_z7chr_37
            {
                  color: #969491 !important;
                  font-family: "Open Sans", sans-serif !important;
                  left: 1.7em !important;
                  top: 1.35em !important;
            }
            ._inline_1qy88_45 {
              display: flex !important;
              align-content: start !important;
              justify-content: start !important;
              margin-left: 3em !important;
          }
         ._formFieldset_16kdc_67
         {
            display:flex !important;
            flex-flow:row  !important;
         }
          
          @media screen and (max-width: 760px) 
          {
                #f1f2b1f0-2f86-47ec-8a6d-3084a09a100e
                {
                    width: 95% !important;
                }
                ._inline_1qy88_45 {
                      margin-left: 0em !important;
                }
                ._formFieldset_16kdc_67 {
                    flex-flow: column wrap !important;
                }
               ._inline_whyqz_45 {
                    padding-left: 0 !important;
                }
                #f1f2b1f0-2f86-47ec-8a6d-3084a09a100e {
                    padding-bottom: 3em;
                }
                ._formSubmitButton_16kdc_81 {
                    width: auto !important;
                }
          }

          
        `;
  
        shadow.appendChild(style);
     }
    
    var intervalEmbedPopup = setInterval(function () 
    {
      var embedRealPopup = document.querySelector('#f1f2b1f0-2f86-47ec-8a6d-3084a09a100e #app-embed');
      if (embedRealPopup) 
      {
        clearInterval(intervalEmbedPopup);
        LoadCssNewsLetterPopup();
      }
    }, 100); 
*/


    /* POPUP CART ABANDONED 
    function LoadCssPopupCartAbandoned()
    {
        var formEmbed = document.querySelector('#app-embed-container-80174');
        var shadow = formEmbed.shadowRoot; 

        let UrlImgAbandonedEnd = window.newslettersVarCart.modalimageabandoned;
  
        var style = document.createElement('style');
        style.textContent = `
              ._formCloseButton_1684x_4._withBackground_1684x_15
              {
                background-color: transparent !important;
              }

              ._gridItemContent_whyqz_254 {
                background: #1f1922 !important;
              }

              ._formHeader_16kdc_19 h2{display:none !important;}

              ._formHeader_16kdc_19 p:nth-child(1)
              {
                      font: 1.1em / 1.6em "Open Sans", sans-serif;
                      color: #969491;
                      margin: 1em 0;
                      display: block;  
                      text-align:left;
              }
              ._formHeader_16kdc_19 p:nth-child(2)
              {
                      font: 1.8em / 1.1em "Open Sans";
                      color: #fff;
                      display: block;
                      margin: 0;
                      text-align:left;
              }
              ._formHeader_16kdc_19 p:nth-child(3)
              {
                    font: 1.1em / 1.6em "Open Sans";
                    color: #fff;
                    margin: 1em 0;
                    display: block;
                    text-align:left;
              }

              #app-embed
              {
                  top:14% !important;
              }
              
              ._formCloseButton_1684x_4 > svg {
                  fill: #FFF !important;
                  fill-opacity: 0.65 !important;
                  width: 20px !important;
                  height: 20px !important;
              }

              div._formFieldContainer_z7chr_5 {
                  margin-block: 0;
                  width: 19em !important;
              }

              div._formFieldContainer_z7chr_5 input{
                  background-color: transparent !important;
                  color: #969491 !important;
                  border: 1px solid #969491 !important;
                  border-radius: 27px !important;
              }

              ._formError_z7chr_20 {
                  position: absolute !important;
                  bottom: 12px !important;
                  margin-left: 22px !important;
              }

              div._formFieldContainer_z7chr_5 label{
                  color: #969491 !important;
                  margin-left: 7px !important;
              }

              button._formSubmitButton_16kdc_81
              {
                    font-weight:bold !important;
                    font-family: "Open Sans" !important;
                    border-radius: 27px !important;
                    width:10em !important;
              }

              ._imageLoaded_whyqz_234
              {
                  height: 22em !important;
                  border-radius: 0 !important;
              }

              div[data-current-step="success"] ._imageLoaded_whyqz_234
              {
                background: url(`+UrlImgAbandonedEnd+`);
              }

              div[data-current-step="success"] div._textBody_2aowh_10
              {
                  display:none !important;
              }

              div[data-current-step="success"]  ._formCloseButton_1684x_4 > svg {
                fill: #000 !important;
                }

              ._grid_whyqz_145 {
                display: flex !important;
                max-width: 50em !important;
                justify-content: start !important;
                align-content: space-between !important;
                justify-items: start !important;
                flex-direction: column !important;
                width: 50em !important;
                border-radius: 0 !important;
            }

            form._formFieldset_16kdc_67 {
                flex-direction: row !Important;
            }

            ._formBannerHeading_1t76a_9
            {
              font: 1.8em / 1.1em "Open Sans" !important;
              color: #fff !important;
              display: block !important;
              margin: 0 !important;
              text-align: left !important;
              padding:0 !important;
            }

            section button._copyToClipboardButton_1q0xm_2
            {
                 font-weight: bold !important;
                font-family: "Open Sans" !important;
                border-radius: 2em !important;
                background: #fcf260 !important;
                color: #000000 !important;
                padding: 0 !important;
                margin: 0 !important;
                margin-top: 2em !important;
                text-align: center;
                padding-top: 7px !important;
                padding-left: 2em !important;
                padding-right: 2em !important;
                padding-bottom: 7px !important;
            }
              span._copyToClipboardText_1q0xm_23 {
            font-size: 18px;
            }
            section button._copyToClipboardButton_1q0xm_2 span
            {
                color: #000000 !important;
            }

            ._copyIcon_1q0xm_31 path {
                display: none !important;
            }

            ._formBannerContainer_1t76a_1
            {
                text-align:left !important;
            }
          ._formCloseButton_1684x_4 > svg {
              fill: #707070 !important;
          }
          @media screen and (max-width: 414px) 
          {
            ._imageLoaded_whyqz_234 {
                height: 11em;
            } 
             ._imageLoaded_whyqz_234
              {
                  height: 17em !important;
                  border-radius: 0 !important;
              }
          }
        `;
  
        shadow.appendChild(style);


        
      var scriptAbandoned = document.createElement('script');
      scriptAbandoned.textContent = `
        var formEmbed = document.querySelector('#app-embed-container-80174');
        
        if (formEmbed && formEmbed.shadowRoot) 
        {
            var submitButton = formEmbed.shadowRoot.querySelector('._withBackground_1684x_15');
            
 
            if (submitButton) {
              submitButton.addEventListener('click', function() 
              {
                    var elemento = document.getElementById('app-embed-container-80174');
                    if (elemento) {
                      elemento.removeAttribute('style');
                    }  
              });
            }    
            
            

            var submitButton = formEmbed.shadowRoot.querySelector('._formSubmitButton_16kdc_81');

            if (submitButton) 
            {
              submitButton.addEventListener('click', function() 
              {
                var intervalId = setInterval(function() {
                  var formEmbed = document.querySelector('#app-embed-container-80174');
                  var error = formEmbed.shadowRoot.querySelector('div[data-current-step="success"] ._formCloseButton_1684x_4');
                  if (error) 
                  {                   
                      clearInterval(intervalId);
                      var submitButton2 = formEmbed.shadowRoot.querySelector('._formCloseButton_1684x_4');
                      if (submitButton2) {
                        submitButton2.addEventListener('click', function() 
                        {
                              var elemento = document.getElementById('app-embed-container-80174');
                              if (elemento) {
                                elemento.removeAttribute('style');
                              }  
                        });
                      } 
                  }
                }, 100); 
          
              });
          }
      }
      `;
      setTimeout(function(){
        shadow.appendChild(scriptAbandoned);  
      }, 1000);
     }
    
    var intervalPopupCart = setInterval(function () 
    {
      var popupCartAbandoned = document.querySelector('#app-embed-container-80174');
      if (popupCartAbandoned) 
      {
        clearInterval(intervalPopupCart);
        LoadCssPopupCartAbandoned();
      }
    }, 100); 
    
*/

  
    /* CONTACT FORM SHOPIFY */
    function LoadCssContactFormShopify()
    {
        var formEmbed = document.querySelector('#shopify-block-forms_inline_kTFJGm form-embed');
        var shadow = formEmbed.shadowRoot; 

        var style = document.createElement('style');
        style.textContent = `

          #form-container-ref section section[data-testid="form-container"]
          {
             max-width: 50em !important;
          }
          
          #form-container-ref section section[data-testid="form-container"] div > form > div
          {
              width: 48% !important;
              margin-bottom: 0.5em !important;
          }
          #form-container-ref section section[data-testid="form-container"] div > form > div:nth-child(3), 
          #form-container-ref section section[data-testid="form-container"] div > form > div:nth-child(4) ,
          #form-container-ref section section[data-testid="form-container"] div > form > div:nth-child(5) 
          {
              width: 100% !important;
          }
          
          #form-container-ref section section[data-testid="form-container"] div > form
          {
              display: flex !important;
              flex-flow: wrap !important;
              justify-content: space-between !important;
          }

          #form-container-ref section section[data-testid="form-container"] div > form > div
          {
            margin-bottom: 1.5em !important;
          }
          
          ._formHeader_16kdc_19
          {
            display:none !important;
          }

          #form-container-ref section section[data-testid="form-container"] div > form > div label{
              text-align: left !important;
              font-family: "Open Sans", sans-serif !important;
              font-size: 1.1em !important;
              padding-left: 0 !important;
              left: 0 !important;
              margin-left: 0 !important;
              color: #1f1922 !important;
              letter-spacing: 0 !important;
          }
          #form-container-ref section section[data-testid="form-container"] div > form > div input
          {
                margin-left: 0 !important;
                text-align: left !important;
                font-family: "Open Sans", sans-serif !important;
                font-size: 1.1em !important;
                height: 2.5em !important;
                min-height: inherit !important;
                letter-spacing: 0 !important;
                background: none !important;
                border: none !important;
                border-bottom: 1px solid #C3BFB8 !important;
                outline: none !important;
                box-shadow: none !important;
                border-radius: 0 !important;
                padding: 0 !important;
                padding-top: 1.5em !important;
          }
          #form-container-ref section section[data-testid="form-container"] div > form > div > p
          {
                font-family: "Open Sans", sans-serif !important;
                font-size: 1.2em !important;
                margin-bottom: 0.35em !important;
          }
          
          #form-container-ref section section[data-testid="form-container"] div > form > div > button
          {
                border: 0 !important;
                border-bottom: 1px solid #C3BFB8 !important;
                margin-left: 0 !important;
                text-align: left !important;
                font-family: "Open Sans", sans-serif !important;
                font-size: 1.1em !important;
                height: 2.1em !important;
                min-height: inherit !important;
                letter-spacing: 0 !important;
                background: transparent !important;
                box-shadow: none!important;
                border-radius: 0px !important;
                padding: 0 !important;
                margin-top: 0.75em;
          }
          ._selectContainer_1ujcz_6 {
                margin-bottom: 1.35em !important;
            }
          textarea[name="custom#comment"]
          {
             border: 0 !important;
            border-bottom: 1px solid #C3BFB8 !important;
            padding-left: 0 !important;
            margin-left: 0 !important;
            text-align: left !important;
            font-family: "Open Sans", sans-serif !important;
            font-size: 1.1em !important;
            padding-bottom: 0 !important;
            height: 2.1em !important;
            min-height: inherit !important;
            letter-spacing: 0 !important;
            background: transparent !important;
            box-shadow: none!important;
            border-radius: 0px !important;
            padding-top: 2em !important;
          }
          
          #form-container-ref section section[data-testid="form-container"] div > form button[data-testid="btn-form-submit"]
          {
              border-radius: 3em;
              border: 0.1875em solid #3657a3;
              outline: 0 none;
              color: #fff;
              font-size: 1.235em;
              font-family: "Open Sans", sans-serif;
              font-weight:600;
              padding: 0.7em 2.4em;
              text-decoration: none;
              width: auto;
              min-width: inherit;
              cursor: pointer;
              display: table;
              margin: 0 auto;
              background: none;
              transition: all .3s ease-in-out;
              background: #3657a3;
          }
          #form-container-ref section section[data-testid="form-container"] div > form button[data-testid="btn-form-submit"]:hover 
          {
              background: #000 !important;
              border:0.1875em solid #000 !important;
          }

          #form-container-ref section section[data-testid="form-container"] div:nth-child(1)[class*="_withError_"] + output + div
          {
               width: 48% !important;
          }

          #form-container-ref section section[data-testid="form-container"] div:nth-child(1)[class*="_withError_"]:after
          {
              content : "First name is required";
              color: #e02229;
              font: normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif;
              bottom: -4px;
              position: relative;
          }

          #form-container-ref section section[data-testid="form-container"] output
          {
              display:none;
          }
          #form-container-ref section section[data-testid="form-container"] div:nth-child(4)[class*="_withError_"]:after
          {
              content : "Email is required";
              color: #e02229;
              font: normal 400 14px Helvetica, Verdana, Geneva, Tahoma, sans-serif;
              bottom: -4px;
              position: relative;
          }

          #form-container-ref section section[data-testid="form-container"] div:nth-child(4)[class*="_withError_"] + output + div,
          #form-container-ref section section[data-testid="form-container"] div:nth-child(4)[class*="_withError_"] + output + div + div
          {
               width: 100% !important;
          }
          
          @media screen and (max-width: 414px) 
          {
            #form-container-ref section section[data-testid="form-container"] div > form > div
            {
                  width: 100% !important;
             }
             #form-container-ref section section[data-testid="form-container"] {
                  max-width: 90% !important;
             }

            #form-container-ref section section[data-testid="form-container"] div:nth-child(1)[class*="_withError_"] + output + div
            {
                 width: 100% !important;
            }
          }
        `;
  
        shadow.appendChild(style);


        
      var scriptAbandoned = document.createElement('script');
      scriptAbandoned.textContent = `
        var formEmbed = document.querySelector('#shopify-block-forms_inline_kTFJGm form-embed');
        
        if (formEmbed && formEmbed.shadowRoot) 
        {
            var submitButton = formEmbed.shadowRoot.querySelector('button[data-testid="btn-form-submit"]');

            if (submitButton) 
            {
                  var script = document.createElement('script');
                  script.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=6Ld5XPspAAAAABnn7VUkDxUb3k6wah02m6JFo50g";
                  script.async = true;
                  script.defer = true;
                  document.head.appendChild(script);

                  var onloadCallback = function() {
                    var form = formEmbed.shadowRoot.querySelector('form'); 
                    form.addEventListener('submit', function(event) 
                    {
                        event.preventDefault();                 
                        grecaptcha.ready(function() 
                        {
                            grecaptcha.execute('6Ld5XPspAAAAABnn7VUkDxUb3k6wah02m6JFo50g', {action: 'submit'}).then(function(token) 
                            {
                                console.log("token", token);
                                var recaptchaResponse = document.createElement('input');
                                recaptchaResponse.setAttribute('type', 'hidden');
                                recaptchaResponse.setAttribute('name', 'g-recaptcha-response');
                                recaptchaResponse.setAttribute('value', token);
                                form.appendChild(recaptchaResponse);


                                var first_name = formEmbed.shadowRoot.querySelector('#first_name').value;
                                var last_name = formEmbed.shadowRoot.querySelector('#last_name').value;
                                var email = formEmbed.shadowRoot.querySelector('#email').value;
                                var comment = formEmbed.shadowRoot.querySelector('textarea').value;
                                
                                if(token == "")
                                {
                                    submitButton.disabled = true;
                                }
                                else{
                                    submitButton.disabled = false;
                                }
                            });
                        });
                    });
                };

            }
        }
      `;
      setTimeout(function(){
        shadow.appendChild(scriptAbandoned);  
      }, 1000);
     }
    
    var intervalContactFormShopify = setInterval(function () 
    {
      var contactFormShopf = document.querySelector('#shopify-block-forms_inline_kTFJGm form-embed');
      if (contactFormShopf) 
      {
        clearInterval(intervalContactFormShopify);
        LoadCssContactFormShopify();
      }
    }, 100); 
    /* END */
});


  function setupClickListener() {
        const elements = document.querySelectorAll('.uploadcare--footer__button');

        elements.forEach(element => {
            element.addEventListener('click', function() {
                const targetElements = document.querySelectorAll('.msg_minimum_order');
                targetElements.forEach(targetElement => {
                    targetElement.remove();
                });
            });
        });
  }

document.addEventListener('DOMContentLoaded', function() {
  
  function setCookieNews(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookieNew(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function hideElementById(id) {
    var element = document.getElementById(id);
    if (element) {
      element.style.display = 'none';
    }
  }

  var cookieName = 'popupHidden1';
  if (getCookieNew(cookieName)) {
    hideElementById('shopify-section-sections--19872002998566__1699503056442a3f3f');
  }

  var buttons = document.querySelectorAll('.button-popup-new');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      
      setCookieNews(cookieName, 'true',3); 
      hideElementById('shopify-section-sections--19872002998566__1699503056442a3f3f');
    });
  });
  

  var buttons2 = document.querySelectorAll('.button-popup');
  buttons2.forEach(function(button) {
    button.addEventListener('click', function() {
      
      setCookieNews("popupAds", 'true', 3); 
      hideElementById('popup');
    });
  });
  
  if (getCookieNew("popupAds")) {
    hideElementById('popup');
  }

  /* POPUP OFFER */  
  var buttons3 = document.querySelectorAll('.button-popup_abandoned');
  buttons3.forEach(function(button) {
    button.addEventListener('click', function() {
      
      setCookieNews("popupOfferAbandoned", 'true', 3); 
      hideElementById('popup_abandoned');
    });
  });
  
  if (getCookieNew("popupOfferAbandoned")) {
    hideElementById('popup_abandoned');
  }
  /* END */

  var detail_product_main2 = document.querySelector('.detail_product_main');
  if(detail_product_main2)
  {
      var buttonRojo = setInterval(function () 
      {
        var elements1 = document.querySelectorAll('.uploadcare--footer__button');
        if(elements1)
        {
          setupClickListener();  
        }
        
      }, 1000);   

      const QtyLinkTmp = document.querySelectorAll('#listdownload').length;
      if(QtyLinkTmp > 0)
      {
          var richTextFields = document.querySelectorAll('.metafield-rich_text_field p a');
          var textValues = Array.from(richTextFields).map(a => a.getAttribute('href'));
          
          var listDownload = document.querySelectorAll('#listdownload')[1]; 
          
          if (textValues.length >= 4 && listDownload) 
          {
              var links = listDownload.querySelectorAll('a[data-url]');
              if (links.length >= 4) 
              {
                  links[0].href = textValues[0]; // Para 'photoshop'
                  links[1].href = textValues[1]; // Para 'ilustrator'
                  links[2].href = textValues[2]; // Para 'indesign'
                  links[3].href = textValues[3]; // Para 'pdf'
              }
          }
      }
  }

  document.querySelectorAll('.faqs .accordion summary').forEach((summaryElement) => {
  summaryElement.addEventListener('click', (event) => {
    setTimeout(() => {
      const detailsElement = summaryElement.parentElement;
      const contentDiv = detailsElement.nextElementSibling;

      if (contentDiv && contentDiv.classList.contains('accordion__content')) {
        if (detailsElement.hasAttribute('open')) {
          contentDiv.style.maxHeight = contentDiv.scrollHeight + "px";
        } else {
          contentDiv.style.maxHeight = "0";
        }
      }
    }, 5);
  });
});



var accordions = document.querySelectorAll('.accordion');
  accordions.forEach(function(accordion) { 
    var details = accordion.querySelector('details'); 
    if (details) {
      var contentDiv = details.querySelector('.accordion__content');
      if (contentDiv) {
        var clonedContent = contentDiv.cloneNode(true);

        details.parentNode.insertBefore(clonedContent, details.nextSibling);
        details.removeChild(contentDiv);
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function() 
{
        var your_shopping_cart = document.querySelector('.your_shopping_cart');
        if(your_shopping_cart)
        {
            var intervalCuponShoppingCart = setInterval(function () 
            {
              var isCupon = document.querySelector('.sc-qb-discount-2017210342');
              if (isCupon) 
              {
                clearInterval(intervalCuponShoppingCart);
                
                var taxNoteElement = document.querySelector('small.tax-note');
                var discountContainerElement = document.querySelector('.sc-qb-discount-container-2017210342');
                if (taxNoteElement && discountContainerElement) 
                {
                    var parentElement = taxNoteElement.parentElement;
                    parentElement.insertBefore(taxNoteElement, discountContainerElement);
                }
              }
            }, 50);   
        }

        const resourceList = document.querySelector('div[aria-labelledby="ResourceList0"]');
        if(resourceList)
        {
            var intervalListCheckout = setInterval(function () 
            {
              var isRow = document.querySelector('div[role="row"]');
              if (isRow) 
              {
                clearInterval(intervalListCheckout);
                
                    const resourceList = document.querySelector('div[aria-labelledby="ResourceList0"]');
                
                    if (resourceList) 
                    {
                        const rows = resourceList.querySelectorAll('div[role="row"]');
                
                        rows.forEach(row => {
                            const ul = row.querySelector('ul');
                
                            if (ul && ul.innerHTML.trim() !== '') {
                                row.classList.add('iscontent');
                            } else {
                                row.classList.add('isemptycontent');
                            }
                        });
                
                        const contentRows = resourceList.querySelectorAll('div.iscontent');
                
                        contentRows.forEach(contentRow => {
                            const listItems = contentRow.querySelectorAll('ul li');
                
                            listItems.forEach(li => {
                                const span = li.querySelector('span');
                                let textContent = span.textContent.trim();
                                let searchContent = textContent.includes(':') ? textContent.split(':')[0].trim() : textContent;
                
                                let previousRow = contentRow.previousElementSibling;
                                while (previousRow && previousRow.matches('div[role="row"]')) {
                                    const firstPInCell = previousRow.querySelector('div[role="cell"] p');
                                    if (firstPInCell && firstPInCell.textContent.trim() === searchContent) {
                                        
                                        const lastCell = previousRow.querySelector('div[role="cell"]:last-child');
                                        if (lastCell) {
                                            span.textContent += ' - ' + lastCell.textContent.trim();
                                            break;
                                        }
                                    }
                                    previousRow = previousRow.previousElementSibling;
                                }
                            });
                        });
                    }

              }
            }, 50);   
        }


  function checkCookie(cookieName) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName + '=') === 0) {
        return true;
      }
    }
    return false;
  }


    var links = document.querySelectorAll('a[href]');
    if(links && links.length > 0)
    {
      links.forEach(function(link)
      {
          var url = link.href;
          var urlObject = new URL(url);
          
          if (urlObject.searchParams.has('v') && urlObject.pathname.endsWith('.ai')) {
           
              urlObject.searchParams.delete('v');
              link.href = urlObject.toString();
          }
      });
    }

});
